import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import type { ActivityWithNft } from "@anaconda/core/activity/types"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { CollectionMoleculeReatom } from "../store/index.reatom"

export const useActivityItems = () => {
  const { collectionActivityQueryParamsAtom } = useMolecule(
    CollectionMoleculeReatom,
  )
  const queryParams = collectionActivityQueryParamsAtom()
  const activityQuery = useSuspenseInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...activityQuery,
      pages: activityQuery.data.pages.map(
        (page: { activities: ActivityWithNft[] }) => ({
          items: page.activities,
        }),
      ),
    }),
    [activityQuery],
  )

  return useInfiniteTableItems(queryResult)
}
